import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Moment from "react-moment";
import SplitPane from "react-split-pane";


const DepotUpdatedHistory = ({
  tableRef,
  onMouseDown,
  historyLoader,
  getStudyDepotAutitTrials,
  depotHistory,
  rowData,
}) => {
  const [history, setHistory] = useState([]);
  const [columnLabel, setColumnLabel] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    setColumnLabel("");
    getStudyDepotAutitTrials();
  }, [rowData]);

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(false);
    }, 500);
  }, [columnLabel]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"30%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {historyLoader ? (
          <PageLoader/>
        ) : depotHistory?.length === 0 ? (
          <NoDataFoundTable MSG={"Depot history not found!"} />
        ) : (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  className="text-center"
                  style={{ width: 45 }}
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Columns</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Latest Version</th>
              </tr>
            </thead>
            <tbody>
              {depotHistory?.map((item, index) => (
                <tr
                  className={`CP ${
                    item?.columnLabel === columnLabel ? "highlighted" : ""
                  }`}
                  onClick={() => {
                    setHistory(item?.history || []);
                    setColumnLabel(item?.columnLabel);
                    setShowLoader(true);
                  }}
                  key={index}
                >
                  <td className="text-center">{index + 1}</td>
                  <td>{item?.columnLabel}</td>
                  <td>{item?.version}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {showLoader ? (
          <PageLoader/>
        ) : history?.length > 0 ? (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th onMouseDown={(e) => onMouseDown(e, 0)}>Version</th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Current Value</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>User Id</th>
                <th onMouseDown={(e) => onMouseDown(e, 3)}>Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {history?.map((element, index) => (
                <tr key={index}>
                  <td>{element?.version}</td>
                  <td>{element?.currentValue}</td>
                  <td>{element?.createdBy}</td>
                  <td>
                    <Moment format="DD MMM YYYY | HH:mm" withTitle>
                      {element.createdAt}
                    </Moment>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <NoDataFoundTable MSG={" Please Select Any Column... "} />
        )}
      </SplitPane>
    </>
  );
};

export default DepotUpdatedHistory;
